import moment from "moment";

export const formatDate = date => {
  if (date===null) return 'nå';
  return moment(date).locale('nb').format('lll');
};
